/*
 * @Description: 选择城市
 * @Author: maowy
 * @Date: 2020-10-21 14:33:31
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: yyyy-08-Th 10:26:01
*/

import Vue from 'vue'
// import _ from 'lodash'
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import { Loading, IndexBar, IndexAnchor } from 'vant'
import selectCityListSearch from './selectCityListSearch/selectCityListSearch'
import {
    getCityList
} from '@/models/selectAddress'

Vue.use(Loading)
Vue.use(IndexBar)
Vue.use(IndexAnchor)

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.selectCityList,
    components: {
        selectCityListSearch
    },
    data () {
        return {
            cityData: {}, // 城市数据
            cityIndexList: [], // 索引A,B
            input_city: '', // 输入城市
            param_city: '', //
        }
    },
    computed: {
        ...mapState({
        }),
    },
    watch: {
        '$route' (to, from) {
        }
    },
    created () {
        this.$emit('setHeader', {
            title: '选择城市',
            showHeader: true,
            showLeft: true
        })
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
        this.param_city = this.$route.query.city
        this.getCityData()
    },
    activated () {
    },
    async mounted () {
    },
    methods: {
        ...mapActions([
            'setAppClass',
        ]),
        getCityData () {
            this.showLoading()
            this.cityData = []
            this.cityIndexList = []
            getCityList({
                city: this.input_city
            }).then(res => {
                this.hideLoading()
                this.cityData = res
                Object.keys(this.cityData).map(key => {
                    this.cityIndexList.push(key)
                })
            }).catch(() => {
                this.hideLoading()
            })
        },
        selectCity (city) {
            this.$router.replace({
                name: 'selectAddress',
                query: {
                    city
                }
            })
        },
        onSearch (city) {
            this.input_city = city
            this.getCityData()
        }
    },

    destroyed () {
    },
}
